import { useEffect, useRef } from "react";
import { toast } from "sonner";

import { CloseIcon } from "@/components/icons/close-icon";
import { Button } from "@/components/ui/button";

interface ToastContentProps {
  onClick(): void;
}

export function ToastContent({ onClick }: ToastContentProps) {
  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: dont worry about it
    // biome-ignore lint/a11y/useKeyWithClickEvents: dont worry about it
    // biome-ignore lint/a11y/noNoninteractiveElementInteractions: legacy
    <div
      className="relative z-100 m-auto max-w-77.5 cursor-pointer rounded-[5px] border border-maize bg-rich-black px-3 py-[11px] text-maize shadow-0-0-10 shadow-maize"
      onClick={onClick}
    >
      <h2 className="text-20/[1em] uppercase">You’re Offline</h2>
      <p className="mt-1 text-12/[1.4em]">
        Morty can’t access the internet. Morty is sad. Please check your
        connection and try again.
      </p>
      <Button aria-label="Close" className="absolute top-2.5 right-2.5 size-6">
        <CloseIcon />
      </Button>
    </div>
  );
}

export default function OfflineBanner() {
  const toastRef = useRef<string | number | undefined>(undefined);

  useEffect(() => {
    const onHide = () => {
      if (toastRef.current) {
        toast.dismiss(toastRef.current);
      }
    };

    const onShow = () => {
      if (toastRef.current) {
        return;
      }

      toastRef.current = toast.custom(
        (id) => <ToastContent onClick={() => toast.dismiss(id)} />,
        {
          duration: Number.POSITIVE_INFINITY,
          onDismiss: () => {
            toastRef.current = undefined;
          },
        }
      );
    };

    const handleOnlineStatusChange = () => {
      if (window.navigator.onLine) {
        onHide();
      } else {
        onShow();
      }
    };

    handleOnlineStatusChange();

    window.addEventListener("online", handleOnlineStatusChange);
    window.addEventListener("offline", handleOnlineStatusChange);

    return () => {
      window.removeEventListener("online", handleOnlineStatusChange);
      window.removeEventListener("offline", handleOnlineStatusChange);
    };
  }, []);

  return null;
}
